import { useFormContext, useWatch } from 'react-hook-form';

export function extractDepFields(condition) {
  if (!condition || typeof condition === 'boolean') return [];
  if (condition.when)  return [condition.when.field];
  if (condition.any)   return condition.any.flatMap(extractDepFields);
  if (condition.all)   return condition.all.flatMap(extractDepFields);
  return [];
}

export function evalCondition(condition, values) {
  if (condition === true || condition === false) return condition;
  if (condition.any) return condition.any.some((c) => evalCondition(c, values));
  if (condition.all) return condition.all.every((c) => evalCondition(c, values));
  if (!condition.when) return false;
  const { field, equals, not_in, in: inList, truthy, starts_with } = condition.when;
  const v = values[field];
  if (truthy      !== undefined) return truthy ? !!v : !v;
  if (equals      !== undefined) return v === equals;
  if (inList      !== undefined) return inList.includes(v);
  if (not_in      !== undefined) return !not_in.includes(v);
  if (starts_with !== undefined) return starts_with.some((p) => String(v ?? '').startsWith(p));
  return false;
}

export function useConditional(condition, defaultValue = false) {
  const { control } = useFormContext();
  // depFields is derived from the static condition object — stable across renders
  const depFields = [...new Set(extractDepFields(condition))];
  const watched   = useWatch({ control, name: depFields });

  if (condition == null) return defaultValue;
  if (condition === true) return true;
  if (condition === false) return false;

  const values = Object.fromEntries(depFields.map((f, i) => [f, watched[i]]));
  return evalCondition(condition, values);
}
